import { render, staticRenderFns } from "./Platforms.vue?vue&type=template&id=b5c9ee0a&"
import script from "./Platforms.vue?vue&type=script&lang=ts&"
export * from "./Platforms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports